import { render, staticRenderFns } from "./ReserveComponent.vue?vue&type=template&id=caa72776&scoped=true"
import script from "./ReserveComponent.vue?vue&type=script&lang=js"
export * from "./ReserveComponent.vue?vue&type=script&lang=js"
import style0 from "./ReserveComponent.vue?vue&type=style&index=0&id=caa72776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa72776",
  null
  
)

export default component.exports